import React from 'react';
import PropTypes from 'prop-types';
import IdentificationsTable from '../../IdentificationsTable';
import PreliminaryAction from './PreliminaryAction';
import SystemState from './SystemState';
import Causes from './Causes';

function Indentification(props) {
  const { srm } = props;
  const identifications = [
    {
      name: 'Preliminary actions',
      component:
  <PreliminaryAction srm={srm} />,
    },
    { name: 'Causes', component: <Causes srm={srm} /> },
    { name: 'System State', component: <SystemState srm={srm} /> },
  ];
  return (
    <div className="w-full mx-auto">
      {identifications.map((identification) => (
        <div key={identification.name} className="rounded-md shadow-md mb-10">
          <IdentificationsTable
            title={identification.name}
            content={identification.component}
            srm={srm}
          />
        </div>
      ))}
    </div>
  );
}
export default Indentification;
// Define PropTypes
Indentification.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  srm: PropTypes.object.isRequired,
};
